// extracted by mini-css-extract-plugin
export default {"wrapper":"DetailBlock_wrapper__Kj9lm","label":"DetailBlock_label__D6co9","value":"DetailBlock_value__1zw24"};